import React, { useContext } from 'react';
import styles from './tabMenuAdmin.module.scss';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { t } from 'i18next';
import { withTranslation } from 'react-i18next';
import { AuthContext } from '../../services/authContextProvider';
import { useNavigate } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { AdminContext } from '../../context/AdminProvider';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface TabMenuAdminProps {
  editRoles?: boolean;
}



function TabMenuAdmin(props: TabMenuAdminProps) {
  const { editRoles } = props;
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const adminContext = useContext(AdminContext);

  const isAuthorized = authContext.canSystem('can_manage_user_roles') || authContext.canSystem('can_read_users');

  const handleNavigation = (route: number) => {
    if (adminContext.isEdition)  adminContext.handleSetIsEdition(false);
    else navigate(route);
  };

  return (
    <div data-testid='tabmenu-test' className={styles.tabMenuContainer}>
      <div className={styles.obraInfo} role='dialog'>
        <div className={isAuthorized ? styles.obraInfoDataAuth : styles.obraInfoData}>
          <div id='goback' className={styles.goBack}>
            <span onClick={() => handleNavigation(-1)
            }><ArrowBackIosIcon /></span>
          </div>
          <div id='tabmenu-idandname' className={styles.idAndName}>
            <Tooltip
              enterDelay={1000}
              arrow
              title={
                <Typography>
                  {t('header.adminPanel')}
                </Typography>
              }
              followCursor
            >
              {editRoles ? (
                <span className={styles.userIdentity}>
                  <span className={styles.userName}>{adminContext.userToEdit?.name}</span>
                  {adminContext.userToEdit?.email && (
                    <span className={styles.userEmail}>{adminContext.userToEdit.email}</span>
                  )}
                </span>
              ) : (
                <span>{t('header.adminPanel')}</span>
              )}
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withTranslation()(TabMenuAdmin);
